// services/locationService.js

const COUNTRIES = [
    { id: 101, name: 'India', code: 'IN' },
    { id: 233, name: 'United States', code: 'US' },
    { id: 232, name: 'United Kingdom', code: 'GB' },
    { id: 38, name: 'Canada', code: 'CA' },
    { id: 13, name: 'Australia', code: 'AU' },
    // Add more countries as needed
  ];
  
  const STATES = {
    101: [ // India
      { id: 4008, name: 'Maharashtra' },
      { id: 4009, name: 'Karnataka' },
      { id: 4010, name: 'Delhi' },
      // Add more states
    ],
    233: [ // United States
      { id: 1416, name: 'California' },
      { id: 1452, name: 'New York' },
      { id: 1454, name: 'Texas' },
      // Add more states
    ],
  };
  
  const CITIES = {
    4008: [ // Maharashtra
      { id: 57606, name: 'Mumbai' },
      { id: 131708, name: 'Pune' },
      // Add more cities
    ],
    1416: [ // California
      { id: 111266, name: 'Los Angeles' },
      { id: 111267, name: 'San Francisco' },
      // Add more cities
    ],
  };
  
  export const getCountries = () => {
    return Promise.resolve(COUNTRIES);
  };
  
  export const getStates = (countryId) => {
    return Promise.resolve(STATES[countryId] || []);
  };
  
  export const getCities = (stateId) => {
    return Promise.resolve(CITIES[stateId] || []);
  };
  
  export const getLocationIds = async (countryName, stateName = null, cityName = null) => {
    const countries = await getCountries();
    const country = countries.find(c => c.name === countryName);
    
    if (!country) {
      return { countryId: null, stateId: null, cityId: null };
    }
  
    const countryId = country.id;
  
    if (!stateName) {
      return { countryId, stateId: null, cityId: null };
    }
  
    const states = await getStates(countryId);
    const state = states.find(s => s.name === stateName);
    
    if (!state) {
      return { countryId, stateId: null, cityId: null };
    }
  
    const stateId = state.id;
  
    if (!cityName) {
      return { countryId, stateId, cityId: null };
    }
  
    const cities = await getCities(stateId);
    const city = cities.find(c => c.name === cityName);
    
    return { 
      countryId, 
      stateId, 
      cityId: city ? city.id : null 
    };
  };